/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Title_3Inputs */

const en_about_title_3 = /** @type {(inputs: About_Title_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the work.`)
};

const lv_about_title_3 = /** @type {(inputs: About_Title_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`izpratni.`)
};

/**
* | output |
* | --- |
* | "the work." |
*
* @param {About_Title_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const about_title_3 = /** @type {((inputs?: About_Title_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Title_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_about_title_3(inputs)
	return en_about_title_3(inputs)
});